import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent {
  redirect:any;
  constructor(private dialogRef: MatDialogRef<ConfirmationPopupComponent>,private toastr:ToastrService,private router:Router) { }
  onCancel() {
    this.dialogRef.close('no')
  }

  onSubmit() {
   this.dialogRef.close('yes')
  }
}